export type AcceptedLanguage = "es" | "pt";

export const acceptedLanguagesCodes: AcceptedLanguage[] = ["es", "pt"];

export const isAcceptedLanguage = (value: string): value is AcceptedLanguage => {
  return acceptedLanguagesCodes.some((a) => a === value);
};
